import { z } from 'zod';
import { I18nStringSchema } from '../../core/i18n';
export const ImageAssetSchema = z.object({
    altText: I18nStringSchema,
    url: z.string()
});
//# sourceMappingURL=imageAsset.js.map